/* eslint-disable camelcase */
import axios from 'axios'
import { wmSign, wmAes, wm_aes_for_web } from '../../apiFunction/encrypt'
import { GetTimeStamp } from '../../apiFunction/getDate'

const appURL = `${process.env.REACT_APP_APP_URL}/api`
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`
const appId = process.env.REACT_APP_ID
const deviceUuid = process.env.REACT_APP_DEVICE_UUID

const baseHeader = {
  'Content-Type': 'application/json',
  'Accept-Language': 'zh-TW',
  'app-id': appId,
  'device-uuid': deviceUuid
}

async function Login (datatest) {
  const body = {
    request_parameter: {
      account: wmAes(datatest.account),
      password: wmAes(datatest.password)

    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${appURL}/member/login`, data, { headers: baseHeader })
  return response.data
}

async function CompareECMember (req) {
  const body = {
    member_access_token: req.memberAccessToken ? req.memberAccessToken : null,
    request_parameter: {
      provider: 'cyberbit',
      phone: req.phone
    },
    timestamp: GetTimeStamp()
  }
  const header = { ...baseHeader, 'Accept-Language': 'en' }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${oauthURL}/member/compare_ec_member`, data, { headers: header })
  return response.data
}

async function GetAuthorize (token) {
  const memberAccessToken = token
  const rurl = sessionStorage.getItem('rurl')
  const xToken = encodeURIComponent(wm_aes_for_web(memberAccessToken))
  const finalUrl = rurl + `&x_token=${xToken}`
  const header = { ...baseHeader, accept: 'application/json', 'X-MMRM-TOKEN': wmAes(memberAccessToken) }
  const response = await axios.get(`${finalUrl}`, { headers: header })
  return response.data
}

export { Login as LoginApiHandler, CompareECMember, GetAuthorize }
